import { apiClient } from './apiClient.ts';

export const projectService = {
    async getProjects() {
        return apiClient.get('/projects');
    },

    async createProject(project: { name: string; research_topic: string; description: string }) {
        return apiClient.post('/projects', project);
    },

    async updateProject(
        project_id: number,
        project: { name: string; research_topic: string; description: string }
    ) {
        return apiClient.put(`/projects/${project_id}/`, project);
    },
};
